import { UseFormWatch } from 'react-hook-form';
import { EditableQuestion, QuestionType } from '../../../../../types';

/**
 * Structured input replaces the plain text box a free text question renders, so it is
 * only offered there. Every other type already collects its answers as options.
 */
export const useShouldShowInputEditor = (watch: UseFormWatch<EditableQuestion>) =>
  watch('type') === QuestionType.FREE_TEXT;
